import { useState } from "react";
import { saveCostCenterOfficeMapping } from "../Api/CostCenterOfficeMapping";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const CostCenterOfficeMapping = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId; 

  const [mappingData, setMappingData] = useState({
    costCenter: "",
    officeCode: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMappingData({
      ...mappingData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCostCenterOfficeMapping(mappingData, userId);
      toast.success(`🦄 Mapping Added Successfully`);
      setMappingData({
        costCenter: "",
        officeCode: ""
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save mapping"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Cost Center Office Mapping</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Cost Center <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="costCenter"
                      value={mappingData.costCenter}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Office Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="officeCode"
                      value={mappingData.officeCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Mapping
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default CostCenterOfficeMapping;